import { Icon, getSvgIcon } from '@helpers/icons';
import { withMotionMax } from '@hoc/withMotionMax';
import * as React from 'react';
import S from './FilterTabButtons.styles';
const FilterTabButtons = (props) => {
    const [open, setOpen] = React.useState(false);
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, { "data-open": open, variants: {
                initial: {
                    height: `var(--buttonHeight)`,
                    boxShadow: 'none',
                },
                open: {
                    height: 'auto',
                    /**
                     * Generated by https://www.joshwcomeau.com/shadow-palette/
                     */
                    boxShadow: `0px 0.4px 0.5px hsl(var(--shadow-color) / 0.19),
        0px 1px 1.2px -0.5px hsl(var(--shadow-color) / 0.21),
        0px 2px 2.4px -1px hsl(var(--shadow-color) / 0.23),
        -0.1px 3.7px 4.5px -1.5px hsl(var(--shadow-color) / 0.25),
        -0.1px 7px 8.5px -1.9px hsl(var(--shadow-color) / 0.28)`,
                },
            }, animate: open ? 'open' : 'initial' }, props.buttons.map((button) => (React.createElement(S.Item, { key: `filter-button-${button.label}-${button.value}`, "data-active": props.active === button.value, "data-hide-dot": props.hideActiveDotMobile ?? 'false' },
            React.createElement(S.Button, { onClick: () => {
                    if (props.active === button.value) {
                        setOpen(!open);
                    }
                    else {
                        props.onButtonClick(button.value);
                        setOpen(false);
                    }
                } },
                React.createElement(S.Icon, null, getSvgIcon(button.icon)),
                React.createElement(S.Text, null,
                    React.createElement(S.Label, null, button.label),
                    button.subLabel && (React.createElement(S.SubLabel, { dangerouslySetInnerHTML: { __html: button.subLabel } }))),
                React.createElement(S.Dot, null),
                React.createElement(S.Chevron, null, getSvgIcon(Icon.Chevron)))))))));
};
export default withMotionMax(FilterTabButtons);
